export default __webpack_public_path__ + "static/22_33-21d8b3b31b65dfc9c87b743ee6f3abf5.png";